import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import Title from './common/Title';

export default function SetGoalsModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationSetGoalsItem;
	onChange: (item: graphql.EvaluationSetGoalsItem, fillInBy: graphql.EvaluationFillInBy) => void;
}) {
	const formik = useFormik({
		initialValues: {
			fillInBy: props.fillInBy,
			title: props.item.title,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		props.onChange(
			{
				...props.item,
				title: formik.values.title,
			},
			formik.values.fillInBy,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.title, formik.values.fillInBy]);

	return (
		<FormikProvider value={formik}>
			<Flex p={3} flexDirection="column">
				<Title />
			</Flex>
		</FormikProvider>
	);
}
